var _style, _defs, _polygon, _defs2, _polygon2, _defs3, _polygon3, _defs4, _polygon4, _defs5, _polygon5, _defs6, _polygon6, _defs7, _polygon7, _defs8, _polygon8, _defs9, _polygon9, _defs10, _polygon10, _defs11, _polygon11, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNavbarA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\r\n\t.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\r\n\t.st2{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\r\n\t.st3{clip-path:url(#SVGID_11_);fill:url(#SVGID_12_);}\r\n\t.st4{clip-path:url(#SVGID_14_);fill:url(#SVGID_15_);}\r\n\t.st5{clip-path:url(#SVGID_17_);fill:url(#SVGID_18_);}\r\n\t.st6{clip-path:url(#SVGID_20_);fill:url(#SVGID_21_);}\r\n\t.st7{clip-path:url(#SVGID_23_);fill:url(#SVGID_24_);}\r\n\t.st8{clip-path:url(#SVGID_26_);fill:url(#SVGID_27_);}\r\n\t.st9{clip-path:url(#SVGID_29_);fill:url(#SVGID_30_);}\r\n\t.st10{clip-path:url(#SVGID_32_);fill:url(#SVGID_33_);}\r\n\t.st11{opacity:0.7;}\r\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st13{fill:#F47421;stroke:#F37321;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st14{fill:#FFFFFF;stroke:#F47421;stroke-width:4;}\r\n\t.st15{fill:#F47421;}\r\n\t.st16{fill:#FFFFFF;stroke:#F47421;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M401.5,147.9c-5.2,55.1,16.8,179.3-61.6,177.4c-68.4-1.7-112.9,71.3-80.2,131.3 c15.3,28,68.5,89.8,40.5,125.2c-17.3,21.8-79.9,34.2-106.9,45.6c-63,26.7-73.5,111.5-18.9,152.7 c47.3,35.7,111.1,61.3,106.1,129.2c-0.7,10.1-3.8,19.9-6.8,29.5c-10.2,32.5-21.5,59.4-36.6,89.5c-32.9,57,5.5,127.8,69.5,132.9 l-0.5,5.1c-6.4,68.1,63.3,117.5,125.5,89c35.3-16.2,70.7-32.4,106-48.6c22.3-10.2,53.2-32,76.9-27.7c50.1,9,64.9,68.1,98,97.7 c16.2,14.5,37.7,22.5,59.4,22.4c6.7,0,63.7-19.8,59.5-22.9c0,0,159.3,120.3,159.3,120.3c54.6,41.2,133.3,7.9,141.7-60 c4.1-33.1-4-64,20.8-87.7c23.3-22.3,55.8-34.3,86-44c47.8-15.3,110.4-24.2,132.2-75c14.6-34.1,23.5-67.6,22.1-100.9 c-1-24.4-7.5-48.6-21.3-72.7c-20-35-40.3-69.8-60.4-104.6l49.5-22.7c62.1-28.5,70.1-113.6,14.4-153.2 c-23.4-16.6-33.7-32.2-51.8-54.1c-7.7-9.4-16.2-18.2-21.8-29c-30.2-58,30.1-100.1,31.1-154.4c0.4-22.8-8.4-45.5-24-62.3 c-3.7-3.9-53.5-35.5-54.5-27.6c0.2-1.3,3.3-26.8,3.3-26.8c8.4-67.9-59.8-119.4-122.8-92.7c-46.6,19.7-93.2,54-143.1,29.1 c-45.5-22.7-66.3-74.8-89.7-115.3c-20.7-35.8-64.3-52.7-103.7-40.3c-45.8,14.3-61.5,63.7-114.5,69.2 c-47.1,4.8-105.7-61.2-142.8-87.5c-16-11.3-33.7-16.5-51.1-16.5C446.9,67.3,406.1,99.3,401.5,147.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.8452,
    y1: -356.4424,
    x2: -205.7548,
    y2: -356.4424,
    gradientTransform: "matrix(-281.3141 876.1326 876.1326 281.3141 254888.0156 282216.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1830.2,195.3 1308.7,1819.3 -279.1,1309.5 242.4,-314.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M122.2,412.7c-21.8,0-39.4,17.6-39.4,39.4c0,13,6.6,25.4,17.4,32.7c11.2,7.6,20.8,5.6,28.6,17.7 c8,12.3,16.7,22.6,32.8,22.6c18.6,0,33.6-15.1,33.6-33.6c0-19.8-12.8-24.2-26.5-32.8c-1.6-1-2.9-2.2-4-3.5 c-6.3-7.5-5.1-19.1-11.3-27.2C146,418.4,134.4,412.7,122.2,412.7C122.2,412.7,122.2,412.7,122.2,412.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.8487,
    y1: -356.8195,
    x2: -205.7503,
    y2: -356.8195,
    gradientTransform: "matrix(-281.3141 876.1326 876.1326 281.3141 254559.0156 282110.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "228,423.2 184.8,557.9 50.1,514.6 93.3,380  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M185.5,562.8c0,13.1,10.6,23.8,23.8,23.8c13.1,0,23.8-10.6,23.8-23.8c0-13.1-10.6-23.8-23.8-23.8 C196.2,539.1,185.5,549.7,185.5,562.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.8418,
    y1: -356.7653,
    x2: -205.7615,
    y2: -356.7653,
    gradientTransform: "matrix(-281.3141 876.1326 876.1326 281.3141 254602.5156 282124.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "246.9,543.5 228.6,600.5 171.7,582.2 190,525.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M1284,281c-2.9,7.5,0.8,15.9,8.3,18.8c7.5,2.9,15.9-0.8,18.8-8.3c2.9-7.5-0.8-15.9-8.3-18.8 c-1.7-0.7-3.5-1-5.3-1C1291.7,271.8,1286.2,275.3,1284,281"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.8464,
    y1: -356.2251,
    x2: -205.7496,
    y2: -356.2251,
    gradientTransform: "matrix(-281.3141 876.1326 876.1326 281.3141 255035.5156 282263.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1323,274.7 1310.9,312.3 1272,299.9 1284.1,262.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M1354.1,265.1c-5.4,13.9,1.5,29.6,15.4,35c13.9,5.4,29.6-1.5,35-15.4c5.4-13.9-1.5-29.6-15.4-35 c-3.2-1.3-6.5-1.9-9.8-1.9C1368.5,247.8,1358.3,254.4,1354.1,265.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.8775,
    y1: -356.0793,
    x2: -205.8054,
    y2: -356.0793,
    gradientTransform: "matrix(-281.3141 876.1326 876.1326 281.3141 254969.5156 282274.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1426.7,253.2 1404.2,323.2 1332,300.1 1354.4,230  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M439.2,1413.6c0,40.9,33.1,74,74,74c40.9,0,74-33.1,74-74c0-40.9-33.1-74-74-74 C472.3,1339.7,439.2,1372.8,439.2,1413.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.8476,
    y1: -356.4531,
    x2: -205.7554,
    y2: -356.4531,
    gradientTransform: "matrix(-281.2991 876.0856 876.0856 281.2991 254838.4531 282189.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "630.2,1353.5 573.3,1530.7 396.1,1473.8 453,1296.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M341.2,1358.2c-3.7,4.3-3.5,13.9-11,12.4c-7.3-1.4-13.6-3.7-21.3-3.4c-14.8,0.7-29,7.5-38.6,18.7 c-19.5,22.7-17,56.9,5.7,76.4c22.7,19.5,56.9,17,76.4-5.7c10.3-12,14.9-28.1,12.4-43.8c-0.6-3.8-1.6-7.4-2.9-11 c-1.1-2.8-4.2-6.6-4.3-9.6c0-0.8,0.1-1.5,0.4-2.1c1.8-3.9,8.8-5,11.4-7.9c6.7-7.7,5.8-19.4-1.9-26.1c-3.5-3-7.8-4.5-12.1-4.5 C350,1351.8,344.9,1354,341.2,1358.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.8516,
    y1: -356.5608,
    x2: -205.7531,
    y2: -356.5608,
    gradientTransform: "matrix(-281.3141 876.1326 876.1326 281.3141 254766.0156 282177.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "413.8,1363.9 364.2,1518.3 212.8,1469.7 262.4,1315.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_22_",
    d: "M564.7,1247.2c0,8.8,7.1,15.9,15.9,15.9c8.8,0,15.9-7.1,15.9-15.9s-7.1-15.9-15.9-15.9 C571.8,1231.3,564.7,1238.4,564.7,1247.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.8645,
    y1: -356.446,
    x2: -205.751,
    y2: -356.446,
    gradientTransform: "matrix(-281.3141 876.1326 876.1326 281.3141 254858.5156 282206.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "605.6,1234.3 593.4,1272.3 555.4,1260.1 567.6,1222.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M596.4,1388.5c0,5.1,4.1,9.3,9.2,9.3c5.1,0,9.2-4.1,9.2-9.3c0-5.1-4.1-9.2-9.2-9.2 C600.5,1379.3,596.4,1383.4,596.4,1388.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.9023,
    y1: -356.4079,
    x2: -205.7444,
    y2: -356.4079,
    gradientTransform: "matrix(-281.3141 876.1326 876.1326 281.3141 254889.0156 282216.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "620.3,1381 613.1,1403.2 591,1396.1 598.1,1373.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_28_",
    d: "M678.3,1330.4c0,12.4,10.1,22.5,22.5,22.5c12.4,0,22.5-10.1,22.5-22.5c0-12.4-10.1-22.5-22.5-22.5 C688.3,1307.9,678.3,1318,678.3,1330.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -207.8492,
    y1: -356.3671,
    x2: -205.7533,
    y2: -356.3671,
    gradientTransform: "matrix(-281.3141 876.1326 876.1326 281.3141 254922.5156 282227.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00515464,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1886,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5758,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FECF0A"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "736.3,1312.1 719,1365.9 665.2,1348.7 682.5,1294.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M380.1,743.5c0,233.1,189,422.1,422.1,422.1c233.1,0,422.1-189,422.1-422.1s-189-422.1-422.1-422.1 C569.1,321.3,380.1,510.3,380.1,743.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: -211.2331,
    y1: -357.0558,
    x2: -209.1432,
    y2: -357.0558,
    gradientTransform: "matrix(7.6634 -851.736 -851.736 -7.6634 -301700.8125 -181397.4375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FECF0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4242,
    style: {
      stopColor: "#F79A1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    style: {
      stopColor: "#F36F21"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#F15C22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15C22"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "372.5,1165.5 380.2,313.8 1232,321.4 1224.3,1173.2  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M791.6,1166.9c0.8-13.2,1.7-26.5,2.4-39.7c1.8-33.5,3.5-67,5.3-100.5c0.5-10.3,1.2-20.5,1.6-30.8 c0.4-12.3-9.9-21.7-22-19.7c-27.8,4.7-55.5,9.6-83.3,14.5c-28.4,5-56.8,10-85.2,15c-0.3,0.1-0.7-0.1-1.5-0.2 c0.5-1.5,0.9-2.8,1.3-4.1c6.8-18.8,13.7-37.6,20.5-56.4c3-8.4,1.8-12.9-5.1-18.5c-60.5-49-120.9-97.9-181.4-146.9 c-0.9-0.7-1.7-1.5-2.9-2.6c5-2.3,9.6-4.5,14.3-6.7c8.6-4,17.2-8,25.8-12c8.1-3.9,10.6-9.7,7.8-18.2 c-11.6-35.8-23.3-71.6-34.9-107.5c-0.4-1.1-0.7-2.2-1.3-4c6.6,1.3,12.7,2.6,18.8,3.9c28.6,6.1,57.2,12.2,85.7,18.3 c9.4,2,14.4-0.6,18.2-9.5c6-14,11.9-28,17.9-41.9c0.5-1.3,1.2-2.6,2.2-4.9c1.4,1.8,2.3,3.2,3.4,4.4c26,27.9,51.9,55.8,78,83.6 c2.2,2.4,5.1,4.8,8.1,5.7c9.2,2.8,17.9-5.1,16.1-14.7c-4.5-24-9.1-48-13.8-72c-8.7-44.7-17.4-89.5-26.1-134.3c-0.1-0.5,0-1,0-2 c1.4,0.8,2.7,1.4,3.9,2c19.4,11.2,38.7,22.4,58.1,33.6c9.8,5.7,16.5,3.6,21.7-6.5c20.8-40.7,41.5-81.5,62.3-122.3 c0.6-1.2,1.3-2.4,2.3-4.1c0.9,1.7,1.6,2.9,2.3,4.1c20.8,40.9,41.6,81.8,62.4,122.6c4.9,9.6,11.8,11.7,21.2,6.3 c19.5-11.2,38.9-22.5,58.4-33.7c1.1-0.6,2.3-1.2,4.1-2.3c-1,5.4-1.8,10.1-2.8,14.8c-11.9,61.5-23.8,122.9-35.8,184.4 c-0.6,3.1-1.2,6.1-1.7,9.2c-0.9,5.6,1.6,10.8,6.4,13.5c4.7,2.7,10.7,2.2,14.9-1.5c1.7-1.4,3.1-3.1,4.6-4.7 c25.8-27.7,51.6-55.4,77.4-83.1c0.7-0.8,1.3-1.6,2.4-2.9c0.9,1.8,1.5,3,2,4.2c6,14.1,12,28.2,18,42.3c3.7,8.8,8.7,11.5,17.9,9.5 c33.5-7.1,67.1-14.2,100.6-21.3c1.3-0.3,2.5-0.5,4.3-0.8c-3.3,10.3-6.4,20.1-9.6,29.9c-8.7,26.8-17.5,53.6-26.2,80.4 c-3.2,10-0.9,15.3,8.6,19.8c12.8,6,25.6,12,39,18.3c-1.3,1.1-2.2,2.1-3.3,2.9c-60.4,48.9-120.7,97.8-181.1,146.6 c-7,5.7-8.3,10-5.2,18.5c6.8,18.8,13.7,37.6,20.5,56.4c0.5,1.3,0.9,2.6,1.5,4.5c-11.2-1.9-21.8-3.7-32.4-5.6 c-38-6.7-76-13.4-114-20.1c-7.9-1.4-15.9-2.9-23.8-4.1c-12.2-1.8-22.6,7.4-22,19.7c1.5,31.3,3.3,62.6,5,93.9 c1.2,22,2.2,43.9,3.4,65.9c0.2,3.8,0.6,7.5,0.9,11.3C815.6,1166.9,803.6,1166.9,791.6,1166.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M876.5,1031.6l-31-102.1H680.7l-31.9,102.1H542.5l155.9-481.9h135.5l153.2,481.9H876.5z M765.7,626.6h-3.5 L694,865.5h138.2L765.7,626.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M940,1032.3l-31-102.1H744.3l-31.9,102.1H606.1L762,550.4h135.5l153.2,481.9H940z M829.3,627.3h-3.5 l-68.2,238.9h138.2L829.3,627.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "974.1,350.8 974.2,427.9 1048.1,427.8 1048.1,461.1 974.2,461.2 974.3,539 939.6,539.1 939.5,461.2  865.6,461.3 865.5,428.1 939.5,428 939.4,350.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "989.6,350.8 989.7,427.9 1063.7,427.8 1063.7,461.1 989.8,461.2 989.8,539 955.2,539.1 955.1,461.2  881.1,461.3 881.1,428.1 955,428 954.9,350.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNavbarA);
export default __webpack_public_path__ + "static/media/logo-navbar-a.7f06acb7f9cb0f72c626673a36ed72d9.svg";
export { ForwardRef as ReactComponent };